var MDAllyMenu = (function($) {
   
   	var menuTL,
   		burgerTL,
   		scrollPos = 0,
   		scrollThreshold = 100,
   		menuRevealAnimation,
   		contentDivs,
   		topbarMenu,
   		burgerButton,
   		expandedMenu,
   		menuOpen = false;

    var onInit = function() {
    	
    	expandedMenu = $('header .top-bar-fixed .expanded');
    	burgerButton = $('header .top-bar-fixed .burger');
    	topbarMenu   = $('header .top-bar-main .top-bar-menu');
    	
    	var topDiv = $('article.page > div:first-of-type, article.page > section:first-of-type');
    	var color = window.getComputedStyle( topDiv[0] ).getPropertyValue( 'background-color' );

    	if( topDiv.hasClass('dark') || rgba2hex(color) == "#09233c") {
    		topbarMenu.addClass('dark');
    	}

    	$('header .top-bar .expanded .expanded-inner #header-expanded-links li').each((i,el)=>{
    		$(el).find('a').wrapInner('<div></div>');
    	});
    	//menuRevealAnimation = gsap.to( topbarMenu , 0.8 , {overwrite: true , yPercent:-100 , paused:true , ease:Power1.easeInOut });
    	if( $('header .red-block').length > 0 ) gsap.set('header .red-block' , { clipPath:'circle(0% at 96.3% 7.8%)'});

    	burgerTL = gsap.timeline({paused:true});
    	burgerTL.add("start" , "+=0");
    	burgerTL.to( burgerButton.find('.t') , 0.2 , {rotation:"+=45" , y:"+=5.2" , transformOrigin:"50% 50%" , ease:Power4.easeInOut } , "start+=0" );
    	burgerTL.to( burgerButton.find('.b') , 0.2, {rotation:"-=45" , y:"-=5.2" , transformOrigin:"50% 50%" , ease:Power4.easeInOut } , "start+=0" );
    	
    	menuTL = gsap.timeline({paused:true});
    	menuTL.add("start" , "+=0");
    	menuTL.add(()=>{ 
    		//topbarMenu.removeClass('on'); 
    		burgerButton.removeClass('on'); 
    	} , "start+=0.3");
    	menuTL.add(()=>{ 
    		//topbarMenu.addClass('on'); 
    		burgerButton.addClass('on'); 
    	} , "start+=0.31");
    	menuTL.fromTo( expandedMenu , 1 , {pointerEvents:'none' , clipPath:'circle(0% at 96.3% 7.8%)'} ,{pointerEvents:'all' , clipPath:'circle(150% at 96.3% 7.8%)' , ease:Power3.easeInOut , onComplete:()=>{
    		if( $('header .red-block').length > 0 ) gsap.set('header .red-block' , {clipPath:'circle(0% at 96.3% 7.8%)'} );
    	}} , "start+=0.1" );
    	menuTL.from( 'header .top-bar .expanded .expanded-inner .menu li a div' , 0.8 , {stagger:0.1, y:'+=120' , ease:Elastic.easeOut.config(0.6,1) } , "start+=0.6" );
    	menuTL.from( 'header .top-bar .expanded .expanded-inner .sub-menu li' , 0.8 , {alpha:0, stagger:0.1, y:"+=20" , ease:Elastic.easeOut.config(0.8,1) } , "start+=0.8" );
    	menuTL.from( 'header .top-bar .expanded .expanded-inner .social-menu li' , 0.8 , {alpha:0, stagger:0.1, y:"+=10" , scale:"-=0.5" , ease:Elastic.easeOut.config(0.8,1) } , "start+=1" );

    	burgerButton.click((e)=>{
    		e.preventDefault();
    		if( menuTL.progress() > 0.4 ) {
    			menuOpen = false;
    			menuTL.timeScale(2).reverse();
    			burgerTL.reverse();
    			if( $('header .red-block').length > 0 ) gsap.to('header .red-block' , 0.2 , {overwrite:true, clipPath:'circle(0% at 96.3% 7.8%)'} );
    			// if( scrollPos > scrollThreshold ) menuRevealAnimation.timeScale(1.5).play();
    		} else {
    			menuOpen = true;
    			menuTL.timeScale(1).play();
    			burgerTL.play();
    			if( $('header .red-block').length > 0 ) gsap.fromTo('header .red-block' , 1.15 , { clipPath:'circle(0% at 96.3% 7.8%)'} ,{ clipPath:'circle(150% at 96.3% 7.8%)' , ease:Power3.easeInOut} );
    			//menuRevealAnimation.reverse();
    		}
    	});

    	$(window).scroll(handleMenuScroll);
    	handleMenuScroll();
    }

    function handleMenuScroll(e) {
    	scrollPos = $(window).scrollTop();
    	//if( !menuOpen ) ( scrollPos > scrollThreshold ) ? menuRevealAnimation.play() : menuRevealAnimation.reverse();
    	
    	/* contentDivs.each((i,el) => {
	        var offset = $(el).offset();
	        var _actPosition = offset.top - s - 100;
	        if( _actPosition < topbar.offset().top && _actPosition + $(el).height() > 0) {
	            var color = window.getComputedStyle( el ).getPropertyValue( 'background-color' );
	            if( rgba2hex(color) == "#09233c" ) {
	            	topbarMenu.addClass('dark');
	            	burgerButton.addClass('dark');
	            } else {
	            	topbarMenu.removeClass('dark');
	            	burgerButton.removeClass('dark');
	            }
	            return false;
	        }
	    });
		*/
	    
    }

    return {
    	init: onInit,
    };

})(jQuery);